import i18n from './i18n';
export default {
  NODE_ENV: process.env.VUE_APP_NODE_ENV,
  BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
  APP_URL: process.env.VUE_APP_URL,
  API_DOMAIN: process.env.VUE_APP_API_DOMAIN,
  SERVER_URL: process.env.VUE_APP_SERVER_URL,
  APP_VERSION: process.env.VUE_APP_BUILD_VERSION,

  /* Layouts of app */
  USE_ROOT: {
    root: true,
  },
  LAYOUT_GUEST: 'LAYOUT_GUEST',


  SUCCESS_COLOR: 'green',
  ERROR_COLOR: 'error',
  SESSION_MODE_CONSUMER: 'consumer',


  THEME: {
    PLATFORM: {
      COLORS: {
        PRIMARY: '#E63293',
        SECONDARY: '#ffffff',
        BACKGROUND: '#263143',
      },
      RTL: false,
      LOCALE: 'en',
    },
  },
  DEFAULT_FONTS : {
    text: 'Alef',
    value: 'Alef',
    url: 'https://fonts.gstatic.com/s/alef/v12/FeVfS0NQpLYgrjJbC5FxxbU.ttf'
  },


  SCREENER_OCCUPIED_SEATS_PERCENTAGE: 75, // Used to show available seats

  EVENT_TYPE: {
    STANDARD_EVENTS: 'StandardEvents',
    VOD_EVENTS: 'VodEvents'
  },

  SCREENER_TYPE_STR: {
    10: i18n.t('defines.screener_type_str.virtual'),
    20: i18n.t('defines.screener_type_str.physical'),
    50: i18n.t('defines.screener_type_str.virtual_and_physical'),
  },
  SCREENER_TYPE_VALUE: {
    VIRTUAL: 10,
    PHYSICAL: 20,
    VIRTUAL_AND_PHYSICAL: 50
  },
};
